/***
 * Отложенная загрузка 
 * @type {{
 * loadPictures: Window.k1ScriptDefault.loadPictures
 * loadScriptCallback: Window.k1ScriptDefault.loadScriptCallback
 * }}
 */

window.k1ScriptDefault = {
	loadPictures: function (array) {
		if (array && array.length > 0) {
			array.forEach(picture => {
				picture.setAttribute('src', picture.getAttribute('data-load-src'))
			})
		}
	},

	loadScript: function(src) {
		let script = document.createElement('script');
		script.src = src;
		script.async = false; //Можем поставить async = true
		document.body.append(script);
	},

	loadScriptCallback: function(url, callback) {
		var script = document.createElement("script");
	  
		if (script.readyState){  // IE
		  script.onreadystatechange = function(){
			if (script.readyState == "loaded" ||
					script.readyState == "complete"){
			  script.onreadystatechange = null;
			  callback();
			}
		  };
		} else { 
		  script.onload = function(){
			callback();
		  };
		}
		
		script.async = false;
		script.type = "text/javascript";
		script.src = url;
		document.body.append(script);
	}
}